import React, { useEffect } from "react";
import { motion } from "framer-motion";
import PortfolioGrid from "../components/PortfolioGrid";
import colors from "../styles/colors";
import { SlArrowDown } from "react-icons/sl";
import ContactUsSection from "../components/HomeSectionContainers/ContactUsSectoin";
import ProductsSection from "../components/HomeSectionContainers/ProductsSection";
import { useTranslation } from "react-i18next";
import SEO from "../utils/SEO";

const Portfolio: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    // Görgetés a lap tetejére az oldal betöltésekor
    window.scrollTo(0, 0);
    // Vízszintes görgetés kikapcsolása
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "auto"; // Visszaállítás, ha másik oldalra navigálsz
    };
  }, []);

  const scrollDown = () => {
    // Az oldal lefelé görgetése 600px-t
    window.scrollBy({ top: 700, left: 0, behavior: "smooth" });
  };

  return (
    <div
      className="min-h-screen w-full overflow-hidden font-serif"
      style={{ backgroundColor: colors.pastelCream }}
    >
      {/* SEO meta tags */}
      <SEO
        title={t("seo_meta.portfolio.metaTitle")}
        description={t("seo_meta.portfolio.metaDescription")}
      />

      {/* title container */}
      <motion.div
        className="h-[80vh] lg:h-screen w-full flex flex-col items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage:
            "url('/assets/images/portfolio/portfolio_main.webp')",
        }}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        {/* Sötétítő réteg  */}
        <div className="h-[80vh] lg:h-screen absolute inset-0 bg-black opacity-20"></div>
        {/* title */}
        <motion.h1
          className="text-4xl sm:text-6xl md:text-8xl mt-24 md:mt-48 z-10"
          style={{ color: colors.lightCream }}
          initial={{ y: 35, opacity: 0 }}
          whileInView={{
            y: 0,
            opacity: 1,
            transition: { delay: 0.2, duration: 0.6 },
          }}
          viewport={{ once: false, amount: 0.5 }}
        >
          {t("portfolioPage.title")}
        </motion.h1>
        {/* subtitle */}
        <motion.p
          className="text-base md:text-2xl mt-4 sm:mt-8 z-10 whitespace-nowrap"
          style={{ color: colors.lightCream }}
          initial={{ y: 20, opacity: 0 }}
          whileInView={{
            y: 0,
            opacity: 1,
            transition: { delay: 0.5, duration: 0.6 },
          }}
          viewport={{ once: false, amount: 0.5 }}
        >
          {t("portfolioPage.subtitle")}
        </motion.p>
        {/* icon */}
        <motion.div
          className="mt-24 sm:mt-48"
          initial={{ y: 20, opacity: 0 }}
          whileInView={{
            y: 0,
            opacity: 1,
            transition: { delay: 1.5, duration: 1 },
          }}
          viewport={{ once: false, amount: 0.5 }}
        >
          <SlArrowDown
            className="text-3xl sm:text-4xl text-white animate-bounce hover:text-gray-300 cursor-pointer"
            onClick={scrollDown}
          />
        </motion.div>
      </motion.div>

      {/* Description Section */}
      <div
        className="py-3 sm:py-6 text-center w-full p-4"
        style={{ backgroundColor: colors.pastelCream }}
      >
        {/* Horizontal Divider */}
        <div
          className="w-full max-h-[20vh] pt-12 pb-12 flex justify-center"
          style={{ backgroundColor: colors.pastelCream }}
        >
          <hr
            className="w-[23%] sm:w-[15%] md:w-[15%] lg:w-[10%] h-0.5 border-t-0 opacity-100 dark:opacity-80"
            style={{ backgroundColor: colors.darkBrown }}
          />
        </div>
        <p
          className="lg:text-2xl text-lg md:text-2xl max-w-2xl mx-auto mt-12"
          style={{ color: colors.darkBrown }}
        >
          {t("portfolioPage.description")}
        </p>
        <p
          className="lg:text-2xl text-lg md:text-2xl max-w-2xl m-2 mx-auto"
          style={{ color: colors.primaryGreen }}
        >
          {t("portfolioPage.clickPrompt")}
        </p>
      </div>

      {/* Portfolio Grid Section */}
      <div className="w-full" style={{ backgroundColor: colors.pastelCream }}>
        <PortfolioGrid />
      </div>

      {/* Horizontal Divider */}
      <div
        className="w-full max-h-[20vh] pt-24 pb-24 flex justify-center"
        style={{ backgroundColor: colors.pastelCream }}
      >
        <hr
          className="w-[23%] sm:w-[15%] md:w-[15%] lg:w-[10%] h-0.5 border-t-0 opacity-100 dark:opacity-80"
          style={{ backgroundColor: colors.darkBrown }}
        />
      </div>

      <ProductsSection />

      {/* Contact Section */}
      <ContactUsSection />
    </div>
  );
};

export default Portfolio;
